import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { AuthService } from '../services/auth.service';
@Injectable()
export class DashBoardService {

    controller:string = 'DashBoard';
    constructor(private http: Http) { }

    GetStatisticTongHop(idCoQuan: number, idSanPham: number, option: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetStatisticTongHop?idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham + "&option=" + option, { headers: headers }).map(resp => resp.json());
    }
    GetPieChart(idCoQuan: number, idSanPham: number, option: number, nangcap: number, loaidoituong: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetPieChart?idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham + "&option=" + option + "&nangcap=" + nangcap + "&loaidoituong=" + loaidoituong, { headers: headers }).map(resp => resp.json());
    }
    GetPieNguoiDungPhanAnh() {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetPieNguoiDungPhanAnh", { headers: headers }).map(resp => resp.json());
    }
    GetPieChart_TongHop(idCoQuan: number, idSanPham: number, option: number, nangcap: number, group: number, loai: number, loaidoituong: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetPieChart_TongHop?idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham + "&option=" + option + "&nangcap=" + nangcap + "&group=" + group + "&loai=" + loai + "&loaidoituong=" + loaidoituong, { headers: headers }).map(resp => resp.json());
    }
    GetPieChart_ChiTiet(page: number, pagesize: number, idDoiTuong: number, idCoQuan: number, idSanPham: number, option: number, nangcap: number, group: number, loai: number, loaidoituong: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetPieChart_ChiTiet?page=" + page + "&pagesize=" + pagesize + "&idDoiTuong=" + idDoiTuong + "&idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham +  "&option=" + option + "&nangcap=" + nangcap + "&group=" + group + "&loai=" + loai + "&loaidoituong=" + loaidoituong, { headers: headers }).map(resp => resp.json());
    }
    GetBarChart(idCoQuan: number, idSanPham: number, option: number, nangcap: number, loaidoituong: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetBarChart?idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham + "&option=" + option + "&nangcap=" + nangcap + "&loaidoituong=" + loaidoituong, { headers: headers }).map(resp => resp.json());
    }
    GetBarDangKy(ngay) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetBarDangKy?ngay=" + ngay, { headers: headers }).map(resp => resp.json());
    }
    GetBarPhanAnh(ngay) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetBarPhanAnh?ngay=" + ngay, { headers: headers }).map(resp => resp.json());
    }
    GetBarChart_TongHop(idCoQuan: number, idSanPham: number, option: number, nangcap: number, group: number, loai: number, ngay: number, loaidoituong: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetBarChart_TongHop?idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham + "&option=" + option + "&nangcap=" + nangcap + "&group=" + group + "&loai=" + loai + "&ngay=" + ngay + "&loaidoituong=" + loaidoituong, { headers: headers }).map(resp => resp.json());
    }
    GetBarChart_ChiTiet(page: number, pagesize: number, idDoiTuong: number, idCoQuan: number, idSanPham: number, option: number, nangcap: number, group: number, loai: number, ngay: number, loaidoituong: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetBarChart_ChiTiet?page=" + page + "&pagesize=" + pagesize + "&idDoiTuong=" + idDoiTuong + "&idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham +  "&option=" + option + "&nangcap=" + nangcap + "&group=" + group + "&loai=" + loai + "&ngay=" + ngay + "&loaidoituong=" + loaidoituong, { headers: headers }).map(resp => resp.json());
    }
    GetBarChart_ChiTietNew(page: number, pagesize: number, idCoQuan: number, idSanPham: number, option: number, loai: number, ngay:number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetPieChart_ChiTietNew?page=" + page + "&pagesize=" + pagesize + "&idCoQuan=" + idCoQuan + "&idSanPham=" + idSanPham +  "&option=" + option + "&loai=" + loai + "&ngay=" + ngay, { headers: headers }).map(resp => resp.json());
    }
    GetListSPByCoQuan(IdCoQuan:number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListSPByCoQuan?IdCoQuan="+ IdCoQuan, { headers: headers }).map(resp => resp.json());       
    }
    ds_DashBoardThietBiCSHT(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_DashBoardThietBiCSHT", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    ds_DashBoardThietBiCSHTKhuVuc(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_DashBoardThietBiCSHTKhuVuc", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    ds_ChiTietThietBiCSHTKhuVuc(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_ChiTietThietBiCSHTKhuVuc", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    ds_ChiTietThietBiCSHT(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_ChiTietThietBiCSHT", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    ds_DashBoardThamDinhPhuongAn(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_DashBoardThamDinhPhuongAn", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    ds_DashBoardThamDinhPhuongAnTinh(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_DashBoardThamDinhPhuongAnTinh", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    ds_ChiTietDeXuatBoSungThietBiTinh(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_ChiTietDeXuatBoSungThietBiTinh", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    ds_ChiTietDeXuatBoSungThietBi(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/ds_ChiTietDeXuatBoSungThietBi", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    DashBoardTongHopTon() {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/DashBoardTongHopTon", {},{ headers: headers }).map(resp => resp.json());       
    }
    DashBoardChiTietTon(data) {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl +this.controller+ "/DashBoardChiTietTon", JSON.stringify(data),{ headers: headers }).map(resp => resp.json());       
    }
    GetBarSLPATheoThang(ngay,linhvuc,chuyenmuc) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarSLPATheoThang?ngay=" + ngay + "&idlinhvuc=" + linhvuc + "&idchuyenmuc=" + chuyenmuc, { headers: headers }).map(resp => resp.json());
    }
    GetBarSLPATheoNgay(ngay,linhvuc,chuyenmuc) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarSLPATheoNgay?ngay=" + ngay + "&idlinhvuc=" + linhvuc + "&idchuyenmuc=" + chuyenmuc, { headers: headers }).map(resp => resp.json());
    }

    GetBarMucDoHaiLong() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarMucDoHaiLong", { headers: headers }).map(resp => resp.json());
    }
    GetBarMucDoHaiLongChiTiet() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarMucDoHaiLongChiTiet", { headers: headers }).map(resp => resp.json());
    }

    GetBarMucDoHaiLongLoc(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + this.controller + "/GetBarMucDoHaiLongLoc", JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    GetBarMucDoHaiLongLocChiTiet(XL) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = XL;
        return this.http.post(Config.apiUrl + this.controller + "/GetBarMucDoHaiLongLocChiTiet", JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    GetBarDonViXuLyQuaHan() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +  this.controller + "/GetBarDonViXuLyQuaHan", { headers: headers }).map(resp => resp.json());
    }

    GetBarDonViXuLyQuaHanLoc(from_date: string, to_date: string, idLinhVuc: number, idChuyenMuc: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let params = new URLSearchParams();
        params.append("from_date", from_date);
        params.append("to_date", to_date);
        params.append("idLinhVuc", idLinhVuc.toString());
        params.append("idChuyenMuc", idChuyenMuc.toString());
        return this.http.get(Config.apiUrl + this.controller + "/GetBarDonViXuLyQuaHanLoc?" + params.toString(), { headers: headers }).map(resp => resp.json());
    }

    GetBarDonViXuLy() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarDonViXuLy", { headers: headers }).map(resp => resp.json());
    }

    GetBarDonViXuLyByDate(from_date: string, to_date: string, idLinhVuc: number, idChuyenMuc: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let params = new URLSearchParams();
        params.append("from_date", from_date);
        params.append("to_date", to_date);
        params.append("idLinhVuc", idLinhVuc.toString());
        params.append("idChuyenMuc", idChuyenMuc.toString());
        return this.http.get(Config.apiUrl + this.controller + "/GetBarDonViXuLyByDate?" + params.toString(), { headers: headers }).map(resp => resp.json());
    }

    DS_ChuyenMuc(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl +  "ThongKeTongHop/DS_ChuyenMuc", JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    DS_LinhVuc() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +"TheodoiPhananh/DS_LinhVuc", { headers: headers }).map(resp => resp.json());       
    } 

    GetBarThongBaoCongViec() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarThongBaoCongViec", { headers: headers }).map(resp => resp.json());
    }
    GetBarThongBaoCongViecChiTiet() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarThongBaoCongViecChiTiet", { headers: headers }).map(resp => resp.json());
    }
    GetBarChuyenMuc() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + "/GetBarChuyenMuc", { headers: headers }).map(resp => resp.json());
    }

    GetBarChuyenMucLoc(from_date: string, to_date: string, idLinhVuc: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let params = new URLSearchParams();
        params.append("from_date", from_date);
        params.append("to_date", to_date);
        params.append("idLinhVuc", idLinhVuc.toString());
        return this.http.get(Config.apiUrl + this.controller + "/GetBarChuyenMucLoc?" + params.toString(), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/home/dashboard.service.ts